import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useMsal } from '@azure/msal-react';
import { clearHttpError, erroHttpErrorSelector } from '../state';
import DialogFlexSales from './DialogFlexSales';
import { loginRedirectRequest } from '../config/auth.config';

const AppErrorAlert = () => {
  const error = useSelector(erroHttpErrorSelector);
  const { instance } = useMsal();
  const handleChangeAccount = useCallback(() => {
    localStorage.removeItem('id-token-claims');
    instance.loginRedirect(loginRedirectRequest);
  }, [instance]);
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const handleClose = useCallback(() => dispatch(clearHttpError()), [dispatch]);
  if (!error) return null;

  const code = error?.innerException?.response?.status;
  let title = '';
  switch (code) {
    case 504:
      title = t('errors.awsError.timeoutTitle');
      break;
    case 403:
      title = t('errors.permissions.title');
      break;
    default:
      title = t('errors.awsError.title');
  }

  const message = i18n.exists(`errors.coded.${code}`)
    ? t(`errors.coded.${code}`)
    : t('errors.awsError.description');

  return (
    <DialogFlexSales open onClose={handleClose} aria-describedby="alert-dialog-error-description">
      <DialogTitle id="draggable-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-error-description">{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        {code === 403 && (
          <Button onClick={handleChangeAccount}>{t('errors.permissions.changeAccount')}</Button>
        )}
        <Button onClick={handleClose}>Ok</Button>
      </DialogActions>
    </DialogFlexSales>
  );
};

export default AppErrorAlert;
